import React from 'react';


import {View, StyleSheet, ScrollView, Image, Dimensions, Text, Animated, BackHandler ,ImageBackground} from "react-native";
import { LinearGradient } from 'expo-linear-gradient';


import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from "axios";

const Splash = ({navigation})=>{

    let token = false;
    let welcome = false;
    let res = false;


    // React.useEffect(()=>{
    //     setTimeout(function(){
    //         navigation.reset({
    //             index: 0,
    //             routes: [{ name: "Friends" }],
    //         });
    //     }, 100);
    // },[]);



    React.useEffect(()=>{

        check();

    },[]);


    const check = async ()=>{

        // let ress = await axios.get(
        //     `https://karzanins.ir/server/1.php`
        // );
        //
        //
        // if(ress.data.active == 0){
        //
        //     res = true;
        // }else if(ress.data.version > 6){
        //
        //     navigation.reset({
        //         index: 0,
        //         routes: [{ name: "Update" ,params: {link : ress.data.link , text : ress.data.text}}],
        //     });
        //     return false;
        // }else{
        //     welcome = await AsyncStorage.getItem('WelcomeSeen');
        //     token = await AsyncStorage.getItem('token');
        // }


        welcome = await AsyncStorage.getItem('WelcomeSeen');
        token = await AsyncStorage.getItem('token');

        res = false;


        setTimeout(function(){
            if(res){

            }
            else if(token){
                navigation.reset({
                    index: 0,
                    routes: [{ name: "Home" }],
                });
            }else if(welcome){
                navigation.reset({
                    index: 0,
                    routes: [{ name: "Login" }],
                });
            }else{
                navigation.reset({
                    index: 0,
                    routes: [{ name: "Welcome" }],
                });
            }

        }, 3000);



    };



    return (
        // https://img.freepik.com/free-photo/money-brazilian-coins-several_58702-6257.jpg?w=740&t=st=1694155345~exp=1694155945~hmac=7da7be1c695f76c36d728a46e2be74200eff58a1e6676d4bc1bde05d5d4a384a

        <ImageBackground

            // source={require('../assets/splashb.jpg')}
            source={{uri: 'https://metamax.network/public/splash.jpg'}}

                         resizeMode="cover"
                         style={{flex : 1 , alignItems : 'center'}}>
       {/*<LinearGradient   colors={['#8e2de2', '#4a00e0']} style={{flexGrow : 1 , backgroundColor : '#FFF',alignItems : 'center' , justifyContent : 'center'}}>*/}


           {/*<Image*/}
           {/*    resizeMode={'stretch'}*/}
           {/*    fadeDuration={999}*/}

           {/*    style={{*/}
           {/*        width : 125,*/}
           {/*        height :125,*/}
           {/*        borderRadius : 15,*/}
           {/*    }}*/}
           {/*    source={require('./../assets/5.gif')}*/}
           {/*/>*/}
           {/*<Image*/}
           {/*    resizeMode={'stretch'}*/}
           {/*    fadeDuration={999}*/}

           {/*    style={{*/}
           {/*        width : 125,*/}
           {/*        height :125,*/}
           {/*        marginTop : 30,*/}
           {/*        borderRadius : 15,*/}

           {/*    }}*/}
           {/*    source={require('./../assets/10.gif')}*/}
           {/*/>*/}
           {/*<Image*/}
           {/*    resizeMode={'stretch'}*/}
           {/*    fadeDuration={999}*/}
           {/*    style={{*/}
           {/*        width : 150,*/}
           {/*        height :50,*/}
           {/*        marginVertical : 0,*/}
           {/*        borderRadius : 15,*/}
           {/*    }}*/}
           {/*    source={require('./../assets/logo.png')}*/}
           {/*    // source={{uri : 'http://maxinvest.io/frontAssets/assets/images/logo/logo-dark.png'}}*/}
           {/*/>*/}


       {/*</LinearGradient>*/}
        </ImageBackground>

    // <ImageBackground   source={require('./../assets/p1.jpg')} resizeMode="cover" style={{flexGrow : 1 , backgroundColor : '#FFF',alignItems : 'center' , justifyContent : 'center'}}>
    //
    //         <Image resizeMode={'stretch'}
    //            fadeDuration={999}
    //            style={{
    //                width : 125,
    //              height :125,
    //                  marginVertical : 70,
    //              borderRadius : 15,
    //
    //           }}
    //             source={require('./../assets/3.gif')}
    //     />
    //
    //     <Image
    //         resizeMode={'stretch'}
    //         fadeDuration={999}
    //         style={{
    //             width : 135,
    //             height :23,
    //             marginVertical : 10,
    //             borderRadius : 15,
    //         }}
    //         source={{uri : 'http://maxinvest.io/frontAssets/assets/images/logo/logo-dark.png'}}
    //     />
    //
    // </ImageBackground>
    );

};


export default Splash;
